module.exports = $;


//////////////////
// WEBPACK FOOTER
// external "$"
// module id = 167
// module chunks = 0